<vivest-card variant="elevated" full-width>
  <div class="card-cabecalho">
    <div>
      @if (titulo()) {
        <h4 class="card-titulo">{{ titulo() }}</h4>
      }
      @if (descricao()) {
        <p class="card-descricao">{{ descricao() }}</p>
      }
    </div>
    <ng-content select="[cardAcao]"></ng-content>
  </div>
  <ng-content></ng-content>
</vivest-card>
